//#region INTERFACE IAutoOrderOpenOrderRefinementFilters

/**
 * Department and sub-department refinement filters for an open auto order.
 */
export interface IAutoOrderOpenOrderRefinementFilters {
  selectedDepartments: string[];
  selectedSubDepartments: string[];
}

//#endregion

//#region CONST AutoOrderOpenOrderRefinementFiltersDefaults

export const AutoOrderOpenOrderRefinementFiltersDefaults: IAutoOrderOpenOrderRefinementFilters = {
  selectedDepartments: [],
  selectedSubDepartments: [],
};

//#endregion
